/* eslint-disable max-lines */
import { gql } from "graphql-tag";

export const getScheduledWorkshopServices = gql`
  query GetScheduledWorkshopServices(
    $serviceType: String  
    $expertId: ID!
    $skip: Int
    $first: Int
    $category: String
    $status: String
    $programId: ID
    $searchString: String
    $fromAcceptedDate: DateTime
    $toAcceptedDate: DateTime
  ) {
    scheduledExpertServices: monitoringScheduledWorkshops(
      orderBy: createdAt_DESC
      where: {
        status: $status
        acceptedAt_gte: $fromAcceptedDate
        acceptedAt_lte: $toAcceptedDate
        assignedExpertService: {
          expertService: {
            expert: { id: $expertId }
            category: $category
            type: $serviceType
          }
          batch: {
            program: {
              id: $programId
            }
          }
          OR: [
            {
              expertService: {
                category: $category
                OR: [
                  { iname_contains: $searchString },
                  { idescription_contains: $searchString },
                  { expert: { ifullName_contains: $searchString } }
                ]
                expert: {
                  id: $expertId
                }
              }
            },
            {
              batch: { program: { iname_contains: $searchString } }
            },
            {
              batch: { iname_contains: $searchString }
            },
            {
              ode: { iname_contains: $searchString }
            }
          ]
        }
      }
      skip: $skip
      first: $first
    ) {
      id
      status
      duration
      assignedExpertService{
        id
        assignationIdentifier
        isProbono
        expertServicePrice
        assignedUnits
        expertServiceData
        assignmentDate
        limitDate
        status
        batch {
          id
          name
          coordinators: users(
            where: { systemRole_in: [COORDINATOR, SUPER_ADMIN] }
          ) {
            id
            fullName
            phone
            email
          }
          program {
            id
            name
          }
        }
        expertService {
          id
          name
          type
          category
          duration
        }
        ode {
          id
          name
        }
      }
    }
    meta: monitoringScheduledWorkshopsConnection(
      where: {
        status: $status
        acceptedAt_gte: $fromAcceptedDate
        acceptedAt_lte: $toAcceptedDate
        assignedExpertService: {
          expertService: {
            expert: { id: $expertId }
            category: $category
            type: $serviceType
          }
          batch: {
            program: {
              id: $programId
            }
          }
          OR: [
            {
              expertService: {
                category: $category
                OR: [
                  { iname_contains: $searchString },
                  { idescription_contains: $searchString },
                  { expert: { ifullName_contains: $searchString } }
                ]
                expert: {
                  id: $expertId
                }
              }
            },
            {
              batch: { program: { iname_contains: $searchString } }
            },
            {
              batch: { iname_contains: $searchString }
            },
            {
              ode: { iname_contains: $searchString }
            }
          ]
        }
      }
    ) {
      aggregate
    }
  }
`;
